<!-- payments PaymentSuccess 违章代缴 支付成功页面-->
<template>
  <div class="success">
    <img :src="icon" alt="" width="100" height="100" class="icon-ok" />
    <p class="tip">支付成功</p>
    <p class="thx">感谢您的支持</p>
    <footer>
      <van-button plain round type="primary" class="btn back" @click="back"
        >返回首页</van-button
      >
    </footer>
  </div>
</template>

<script>
export default {
  name: "Success",
  data() {
    // 这里存放数据
    return {
      icon:
        "https://app-h5.gwmapp-h.com/app-web/gw-community/img/icon-ok@2x.png"
    };
  },
  methods: {
    back() {
      // 关闭 webview
      this.$bridge.call("Controller.popToRootViewController");
    }
  }
};
</script>
<style lang="scss" scoped>
// @import url(); 引入公共css类
@import "../../asset/scss/mixin.scss";

.success {
  width: 100%;
  text-align: center;
  font-family: PingFangSC-Medium, PingFang SC;

  .icon-ok {
    width: pxTorem(128/2);
    height: pxTorem(128/2);
    margin: pxTorem(115/2) auto pxTorem(40/2);
  }

  .tip {
    font-size: pxTorem(42/2);
    font-weight: 500;
    color: rgba(51, 51, 53, 1);
    margin: 0 auto pxTorem(16/2);
  }

  .thx {
    font-size: pxTorem(24/2);
    font-weight: 400;
    color: rgba(101, 101, 102, 1);
    margin: 0 auto pxTorem(40/2);
  }

  .money {
    font-size: pxTorem(72/2);
    font-weight: 500;
    color: rgba(51, 51, 53, 1);

    i {
      font-size: pxTorem(36/2);
      margin-right: pxTorem(16/2);
    }
  }

  footer {
    width: 100%;
    height: pxTorem(130/2);
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 pxTorem(42/2);
    margin: pxTorem(200/2) 0;

    .btn {
      flex: 0 1 pxTorem(320/2);
      height: pxTorem(82/2);
      line-height: pxTorem(82/2);
      width: pxTorem(320/2);
      font-size: pxTorem(28/2);
      background-color: #2d2d2d;
      border: 1px solid #353333;

      &.back {
        color: #353333;
        background-color: #fff;
      }
    }
  }
}
</style>
